import { Component, Input, HostListener, EventEmitter, ViewChild, ElementRef, Output } from '@angular/core';
import { IonicPage, NavParams, Platform, ViewController } from 'ionic-angular';
import { CallProvider } from '../../providers/call/call';
import { TranslateService } from '@ngx-translate/core';
import * as $ from 'jquery';


/**
 * Generated class for the RmtModalComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'rmt-modal',
  templateUrl: 'rmt-modal.html'
})
export class RmtModalComponent {
  @ViewChild('modalIndicator', {read: ElementRef}) modalIndicator: ElementRef;
  @Input() showFullModal: boolean = false;
  @Input() modalTitle: string = "";
  @Input() showBack: boolean = false;
  @Input() indicationBgTransparent: boolean = false;
  @Input() whiteBackground: boolean = false;
  @Input() longSwipe: boolean = false; // enable scrolling inside the modal
  @Output() clickButton = new EventEmitter<number>();
  mobileIndicatorDiv;

  currentPosition;
  height;
  minimumThreashold;
  startPosition = 0;
  // TODO: Remove the below implementation and integrate Stephan's changes when it is merged to development

  defaultTouch = { x: 0, y: 0, time: 0 };
  @HostListener('touchstart', ['$event'])
  @HostListener('touchend', ['$event'])
  handleTouch(event) {
    if (!this.showFullModal) {
      let touch = event.touches[0] || event.changedTouches[0];
      // check the events
      if (event.type === 'touchstart') {
        this.defaultTouch.x = touch.pageX;
        this.defaultTouch.y = touch.pageY;
        this.defaultTouch.time = event.timeStamp;
      } else if (event.type === 'touchend') {
        let deltaX = touch.pageX - this.defaultTouch.x;
        let deltaY = touch.pageY - this.defaultTouch.y;
        let deltaTime = event.timeStamp - this.defaultTouch.time;
        // simulte a swipe -> less than 500 ms and more than 60 px
        if (deltaTime < 500) {
          // touch movement lasted less than 500 ms
          if (Math.abs(deltaX) > 60) {
            // delta x is at least 60 pixels
            if (deltaX > 0) {
              this.doSwipeRight(event);
            } else {
              this.doSwipeLeft(event);
            }
          }
          if (Math.abs(deltaY) > 60) {
            // delta y is at least 60 pixels
            if(this.longSwipe && deltaY > 350) { 
              this.doSwipeDown(event);
            }else if (deltaY > 0 && !this.longSwipe)  {
              this.doSwipeDown(event);
            } else {
              this.doSwipeUp(event);
            }
          }
        }
      }
    }
  }
  
  constructor(
    private call: CallProvider,
    private navParams: NavParams,
    private platform: Platform,
    private translate: TranslateService,
    private viewCtrl: ViewController,
  ) {
  }

  async ngAfterViewInit() {
    this.mobileIndicatorDiv = $(this.modalIndicator.nativeElement)[0];
  }

  processButton(ev, i) {
    ev.stopPropagation(); // if there is a click listener on the card itself    
    this.clickButton.emit(i);
  }

  touchMove(evt: TouchEvent) {
    if (!this.showFullModal) {
      if (this.startPosition == 0)
        this.startPosition = evt.touches[0].clientY;

      this.height = this.mobileIndicatorDiv.clientHeight;
      const y = evt.touches[0].clientY;
      this.currentPosition = y - this.startPosition;
      if (this.currentPosition > 0 && this.startPosition > 0) {
        this.mobileIndicatorDiv.style.transform = `translate3d(0px,${this.currentPosition}px,0px)`;
      }
    }
  }

  touchEnd() {
    if (!this.showFullModal) {
      this.minimumThreashold = this.height * 0.7;

      if (this.currentPosition < this.minimumThreashold) {
        this.mobileIndicatorDiv.style.transform = "translate3d(0px, 0px, 0px)";
      } else {
        this.dismissModalAlert();
      }
    }
  }

  getModalClass() {
    let cssClass = '';
    if (!this.showFullModal && this.modalTitle) {
      cssClass = 'bottomsheet modal-title__header';
    } else if (this.showFullModal) {
      cssClass = 'fullscreen';
    }
    else if (this.indicationBgTransparent) {
      cssClass = 'bottomsheet modal-title__header'
    }
    else {
      cssClass = 'bottomsheet';
    }
    if(this.whiteBackground) {
      cssClass += ' modal_white_bg';
    }
    return cssClass;
  }

  onGesture() {
    this.dismissModalAlert();
  }

  dismissModalAlert() {
    this.startPosition = 0;
    this.currentPosition = 0;
    this.mobileIndicatorDiv.style.transform = "translate3d(0px, 0px, 0px)";
    this.viewCtrl.dismiss();
  }

  doSwipeLeft(event) {}

  doSwipeRight(event) {}

  doSwipeUp(event) {}

  doSwipeDown(event) {
    this.dismissModalAlert();
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-modal/rmt-modal.ts